import bilAPI from "./api";

// The token in the path IS the authorization for these two — they are public,
// and the backend answers every failure mode (unknown / expired / already used
// / superseded) with the same 404, so callers must not try to distinguish them.
export const getInvitation = ({ token, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/auth/invitations/${encodeURIComponent(token)}/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Resolves `{ access, refresh }` — accepting signs the user straight in rather
// than bouncing them to a login form to retype the password they just chose.
export const acceptInvitation = ({ token, body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/invitations/${encodeURIComponent(token)}/accept/`, body, {
          signal,
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Manager action: issue a fresh invitation and email it, revoking any
// outstanding one. Also the only administrative password-reset path there is.
export const resendInvitation = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/users/${uuid}/invite/`, null, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
